/* eslint-disable no-useless-escape */

import React from 'react'
import Link from './Link'
import PropTypes from 'prop-types'
import { buttonThemes } from '~helpers/content'
import classNames from 'classnames'

class ButtonLink extends Link {
  render () {
    const { className, children, theme } = this.props

    return (
      <Link
        href={this.props.href}
        className={classNames(
          'py-4 px-6 inline-block border outline-none text-center appearance-none transition-colors duration-200 ease-in-out',
          buttonThemes[theme || 'primary'],
          className
        )}
      >
        {children}
      </Link>
    )
  }
}

ButtonLink.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string.isRequired,
  theme: PropTypes.string,
  className: PropTypes.string
}

export default ButtonLink
